import api from './api';

export const doctorService = {
  getAllDoctors: (params) => api.get('/doctors', { params }),
  getDoctorById: (id) => api.get(`/doctors/${id}`),
  getDoctorsBySpecialization: (specializationId) => 
    api.get('/doctors', { params: { specialization_id: specializationId } }),
};

export const departmentService = {
  getAllDepartments: () => api.get('/departments'),
  getDepartmentById: (id) => api.get(`/departments/${id}`),
};
